module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "微信门店管理",
      "name": "first"
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "请先确认您是否已经开通门店小程序！",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v("\n              如果没有请点击 "), _c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com"
    }
  }, [_vm._v("开通门店小程序")]), _vm._v("，去微信后台添加或者升级门店小程序\n            ")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n          店铺类型：\n          "), _c('el-select', {
    on: {
      "change": _vm.storeChange
    },
    model: {
      value: (_vm.store_type),
      callback: function($$v) {
        _vm.store_type = $$v
      },
      expression: "store_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "直营店",
      "value": 1
    }
  }, [_vm._v("直营店")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "非直营店",
      "value": 2
    }
  }, [_vm._v("非直营店")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 12
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.matchHidePage('editor')
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    }
  }, [_vm._v("添加门店")])], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "同步微信门店到本地",
      "placement": "right-start"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-refresh"
    },
    on: {
      "click": function($event) {
        return _vm.syncWxShops()
      }
    }
  }, [_vm._v(" 同步门店")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.wxShopsList,
      "height": _vm.wheight - 305
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "storeName",
      "label": "门店名称",
      "width": "240"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isDirectStore",
      "label": "直营店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDirectStore === 1) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("直营")])], 1) : _vm._e(), _vm._v(" "), (scope.row.isDirectStore === 2) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v("非直营")])], 1) : _vm._e()]
      }
    }], null, false, 2074105635)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "240",
      "label": "地理位置"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDomestic == 2) ? _c('div', [_vm._v("\n              " + _vm._s(scope.row.country) + " " + _vm._s(scope.row.city) + " " + _vm._s(scope.row.address) + "\n            ")]) : _c('div', [_vm._v("\n              " + _vm._s(scope.row.address) + "\n            ")])]
      }
    }], null, false, 2220752629)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#efefef"
          },
          on: {
            "change": function($event) {
              return _vm.setStatus(scope.row)
            }
          },
          model: {
            value: (scope.row.isOpen),
            callback: function($$v) {
              _vm.$set(scope.row, "isOpen", $$v)
            },
            expression: "scope.row.isOpen"
          }
        })]
      }
    }], null, false, 2052898668)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expiredAt",
      "label": "到期时间",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.expiredAt && scope.row.is_valid) ? _c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.expiredAt, 'yyyy-MM-dd hh:mm:ss')))]) : (scope.row.expiredAt && !scope.row.is_valid) ? _c('span', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已过期")])], 1) : _c('span', [_vm._v(" -- ")])]
      }
    }], null, false, 3281899560)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "设为默认",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "active-color": "#13ce66",
            "inactive-color": "#efefef",
            "disabled": scope.row.isDefault ? true : false
          },
          on: {
            "change": function($event) {
              return _vm.setDefault(scope.row)
            }
          },
          model: {
            value: (scope.row.isDefault),
            callback: function($$v) {
              _vm.$set(scope.row, "isDefault", $$v)
            },
            expression: "scope.row.isDefault"
          }
        })]
      }
    }], null, false, 996377205)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.is_valid) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getRes(scope.row)
            }
          }
        }, [_vm._v("激活")]) : _vm._e(), _vm._v(" "), (1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.wxShopsEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text",
            "disabled": true
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.wxShopsDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 4094149594)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.pageLimit) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.total_count,
      "page-size": _vm.pageLimit
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "resource-dialog",
    attrs: {
      "title": "资源列表",
      "close-on-click-modal": false,
      "visible": _vm.dialogTableVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-table', {
    ref: "resource_list",
    attrs: {
      "data": _vm.resourceList,
      "max-height": "420",
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.resCurrentChange,
      "row-click": _vm.getResId
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "激活时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.activeAt, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 3616567371)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resourceName",
      "label": "资源名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftShopNum",
      "label": "剩余门店数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "到期期时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.expiredAt, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 574150672)
  })], 1), _vm._v(" "), (_vm.resourceCount > _vm.pageLimit) ? _c('div', {
    staticClass: "content-center"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.resourceCount,
      "page-size": _vm.pageLimit
    },
    on: {
      "current-change": _vm.reshandleCurrentChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelRes()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setResource
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "门店详情",
      "visible": _vm.wxShopsDetailVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.wxShopsDetailVisible = $event
      }
    }
  }, [
    [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("当前状态")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(_vm.wxShopsDetailData.status === 1) ? _c('div', [_vm._v("\n                已通过\n              ")]) : _vm._e(), _vm._v(" "), (_vm.wxShopsDetailData.status === 2) ? _c('div', [_vm._v("\n                审核中\n              ")]) : _vm._e(), _vm._v(" "), (_vm.wxShopsDetailData.status === 3) ? _c('div', [_vm._v("\n                审核失败\n              ")]) : _vm._e(), _vm._v(" "), (_vm.wxShopsDetailData.status === 4) ? _c('div', [_vm._v("\n                审核驳回\n              ")]) : _vm._e()])], 1), _vm._v(" "), (_vm.wxShopsDetailData.status == '3') ? _c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("未通过原因")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.wxShopsDetailData.errmsg))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("门店名称")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.wxShopsDetailData.company_name))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("地理位置")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.wxShopsDetailData.address))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("地理位置")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_c('img', {
      attrs: {
        "src": _vm.wxShopsDetailData.qqmapimg
      }
    })])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("联系电话")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.wxShopsDetailData.contract_phone))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("经营资质证件号")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.wxShopsDetailData.credential))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("营业时间")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.wxShopsDetailData.hour))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("门店图片")])]), _vm._v(" "), _vm._l((_vm.wxShopsDetailData.pic_list), function(pic, index) {
      return _c('el-col', {
        key: pic,
        attrs: {
          "span": 1,
          "offset": index > 0 ? 1 : 0
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.wximageurl + pic,
          "width": "40",
          "height": "40"
        }
      })])
    })], 2)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.wxShopsDetailVisible = false
        }
      }
    }, [_vm._v("取消")])], 1)
  ], 2)], 1), _vm._v(" "), _c('el-tab-pane', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "label": "可用资源包列表",
      "name": "resourceList"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.resourceList,
      "height": _vm.wheight - 110
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "resourceName",
      "label": "资源名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shopNum",
      "label": "包含门店数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leftShopNum",
      "label": "剩余门店数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "激活时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.activeAt, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 3616567371)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "到期期时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.expiredAt, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 574150672)
  })], 1), _vm._v(" "), (_vm.resourceCount > _vm.pageLimit) ? _c('div', {
    staticClass: "content-center content-padded"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.resourceCount,
      "page-size": _vm.pageLimit
    },
    on: {
      "current-change": _vm.reshandleCurrentChange
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-680c0605", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-680c0605"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/shop/wxshop.vue
// module id = 2792
// module chunks = 0